import type { Shortcut } from "./shortcut-registry";

export const RESERVED_SHORTCUTS: readonly Omit<Shortcut, "label">[] = [
  { id: "platform:command-palette", keys: "Cmd+K", scope: "global" },
  { id: "platform:search", keys: "/", scope: "global" },
  { id: "platform:help-overlay", keys: "?", scope: "global" },
  { id: "platform:close", keys: "Escape", scope: "global" },
  { id: "platform:save", keys: "Cmd+S", scope: "form" },
  { id: "platform:submit", keys: "Cmd+Enter", scope: "form" },
  { id: "platform:new", keys: "n", scope: "list" },
  { id: "platform:edit", keys: "e", scope: "detail" },
  { id: "platform:next-row", keys: "j", scope: "list" },
  { id: "platform:prev-row", keys: "k", scope: "list" },
  { id: "platform:goto-module", keys: "g m", scope: "global" },
] as const;
